import { action, computed, makeObservable } from 'mobx';
import {RoleName, UserSearchModel, UserStatusType} from '../../../domain/models/user';
import {Control, StringControl, validators} from '../../../lib/helpers';

export class UserSearchFormStore {
  filter: StringControl;
  status: Control<UserStatusType | null>;
  roles: Control<RoleName[]>;
  creationDateTime: StringControl;
  lastLoginDateTime: StringControl;

  constructor() {
    makeObservable(this);
    this.filter = new StringControl('', '');
    this.status = new Control<UserStatusType | null>('', null);
    this.roles = new Control<RoleName[]>('', []);
    this.creationDateTime = new StringControl('', '', validators.dateRange);
    this.lastLoginDateTime = new StringControl('', '', validators.dateRange);
  }

  @computed
  get invalid(): boolean {
    return this.creationDateTime.invalid ||
      this.lastLoginDateTime.invalid;
  }

  @action
  markAllTouched() {
    this.creationDateTime.markTouched();
    this.lastLoginDateTime.markTouched();
  }

  @computed
  get model(): UserSearchModel {
    return {
      Page: 0,

      Filter: this.filter.value,
      Status: this.status.value,
      CreationDateTime: this.creationDateTime.value,
      LastLoginDateTime: this.lastLoginDateTime.value,
      Roles: this.roles.value,
    };
  }
}
